import { type UnityElement, type UnityState } from '@@editor/typings/UnityElements';

import { SCHEMA } from './../constants';

const unwrapSerializedState = (state: UnityState): UnityElement[] =>
    state != null ? state[SCHEMA.UNITY] : state;

export default unwrapSerializedState;
